export const toggleLabelTypes = {
    icon: 'icon',
    none: 'none',
    text: 'text',
};
export const toggleSizes = {
    large: 'large',
    medium: 'medium',
    small: 'small',
};
export const outerLabelPositions = {
    left: 'left',
    right: 'right',
};
